/** Pathnames, without a trailing slash, of the routes that run the Auth0 login and logout handshake. */
const AUTH_FLOW_PATHNAMES = ['/log-in', '/log-out', '/logged-out', '/callback', '/verify-email'];

/**
 * Whether the given pathname is one of the login/logout handshake routes. These pages navigate the
 * browser away on their own, so a second navigation started from them competes with that redirect.
 *
 * @param pathname - A URL pathname (e.g. `window.location.pathname`), with or without a trailing slash.
 * @returns True when the pathname is an auth-flow route.
 */
export function isAuthFlowPathname(pathname: string): boolean {
	return AUTH_FLOW_PATHNAMES.includes(pathname.replace(/\/$/, ''));
}
